import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
var sizes = {
  sm: {
    width: '82px',
    height: '64px'
  },
  md: {
    width: '280px',
    height: '202px'
  }
};
var AgroImage = withCssProps(function (_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'agro-image' : _ref$alt,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$fit = _ref.fit,
    fit = _ref$fit === void 0 ? 'cover' : _ref$fit,
    height = _ref.height,
    onError = _ref.onError,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    src = _ref.src,
    width = _ref.width;
  var handleError = function handleError(e) {
    if (onError) {
      onError(e);
    }
  };
  return /*#__PURE__*/React.createElement(Img, {
    alt: alt,
    className: className,
    fit: fit,
    height: height || sizes[size].height,
    onError: function onError(e) {
      return handleError(e);
    },
    src: src,
    width: width || sizes[size].width
  });
});
AgroImage.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  fit: PropTypes.oneOf(['cover', 'contain', 'none']),
  height: PropTypes.string,
  onError: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md']),
  src: PropTypes.string.isRequired,
  width: PropTypes.string
};
AgroImage.displayName = 'AgroImage';
export { AgroImage };
var Img = styled.img.withConfig({
  displayName: "AgroImage__Img",
  componentId: "sc-1bqt41q-0"
})(["display:inline-block;-o-object-fit:", ";object-fit:", ";width:100%;height:100%;border-radius:8px;border:1px solid ", ";width:", ";height:", ";"], function (_ref2) {
  var fit = _ref2.fit;
  return fit;
}, function (_ref3) {
  var fit = _ref3.fit;
  return fit;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.gray300;
}, function (_ref5) {
  var width = _ref5.width;
  return width;
}, function (_ref6) {
  var height = _ref6.height;
  return height;
});